import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const tabs = ['Preguntas Generales', 'Proceso de Aplicación', 'Elegibilidad y Requisitos', 'Tipos de Financiamiento', 'Cuenta y Seguridad'];
const faqsByTab: Record<string, {
  question: string;
  answer: string;
}[]> = {
  'Preguntas Generales': [{
    question: '¿Son ustedes prestamistas?',
    answer: 'No, somos brokers de financiamiento. Comparamos más de 75 prestamistas privados para encontrarte la mejor oferta, para que no tengas que conformarte con la primera opción.'
  }, {
    question: '¿Cuánto financiamiento puedo obtener?',
    answer: 'El monto depende de factores como tus ingresos mensuales, tiempo en el negocio y perfil crediticio. Algunos negocios califican desde $10,000 hasta $3,000,000 o más.'
  }, {
    question: '¿Cobran algún cargo por aplicar?',
    answer: 'No, aplicar es completamente gratis. No cobramos cargos iniciales. Solo nos pagan cuando obtienes tu financiamiento aprobado.'
  }, {
    question: '¿Qué tan rápido puedo recibir los fondos?',
    answer: 'Muchas aprobaciones ocurren en 24 horas y los fondos se depositan en tu cuenta bancaria a través de ACH en un periodo de 24-48 horas hábiles.'
  }, {
    question: '¿En qué estados operan?',
    answer: 'Trabajamos con negocios en todos los estados de Estados Unidos. No importa dónde esté ubicado tu negocio, podemos ayudarte a encontrar financiamiento.'
  }],
  'Proceso de Aplicación': [{
    question: '¿Cómo es el proceso de aplicación?',
    answer: 'Es muy sencillo: completas nuestro formulario en línea en menos de 5 minutos, enviamos tu aplicación a nuestra red de prestamistas, comparamos ofertas y te presentamos las mejores opciones.'
  }, {
    question: '¿Qué documentos necesito para aplicar?',
    answer: 'Generalmente necesitas los últimos 3-4 meses de estados de cuenta bancarios de tu negocio. Dependiendo del tipo de financiamiento, podrían solicitarse documentos adicionales.'
  }, {
    question: '¿Cuánto tiempo toma completar la aplicación?',
    answer: 'El formulario de aplicación se completa en menos de 5 minutos. Una vez enviado, nuestro equipo comienza a comparar ofertas de inmediato.'
  }, {
    question: '¿Puedo aplicar por WhatsApp?',
    answer: 'Sí, ofrecemos atención personalizada por WhatsApp. Puedes iniciar tu aplicación, hacer preguntas y recibir actualizaciones directamente por este medio.'
  }, {
    question: '¿Qué pasa después de enviar mi aplicación?',
    answer: 'Enviamos tu aplicación a nuestra red de más de 75 prestamistas privados, comparamos las ofertas recibidas y te contactamos con las mejores opciones disponibles para tu negocio.'
  }],
  'Elegibilidad y Requisitos': [{
    question: '¿Cuáles son los requisitos mínimos?',
    answer: 'Los requisitos básicos son: tener al menos 6 meses operando tu negocio, generar un mínimo de $10,000 en ingresos mensuales y tener una cuenta bancaria comercial activa.'
  }, {
    question: '¿Necesito buen crédito para calificar?',
    answer: 'No necesariamente. Trabajamos con prestamistas que consideran múltiples factores además del crédito, como ingresos y tiempo en el negocio. Hay opciones disponibles para diferentes perfiles crediticios.'
  }, {
    question: '¿Aplicar afecta mi puntaje de crédito?',
    answer: 'En la mayoría de los casos, la evaluación inicial es un "soft pull" que no afecta tu crédito. Algunas opciones de financiamiento pueden requerir una revisión crediticia más adelante.'
  }, {
    question: '¿Puedo aplicar si mi negocio es nuevo?',
    answer: 'Necesitas al menos 6 meses de operación. Si tu negocio es más nuevo, te recomendamos contactarnos para evaluar opciones alternativas que puedan funcionar para ti.'
  }, {
    question: '¿Qué tipos de negocios califican?',
    answer: 'Trabajamos con una amplia variedad de industrias: restaurantes, construcción, transporte, bienes raíces, tiendas minoristas, servicios profesionales y muchos más.'
  }],
  'Tipos de Financiamiento': [{
    question: '¿Qué tipos de financiamiento ofrecen?',
    answer: 'Ofrecemos múltiples opciones incluyendo: adelanto de efectivo para comerciantes (MCA), líneas de crédito, préstamos a plazo, financiamiento de equipos y financiamiento basado en ingresos.'
  }, {
    question: '¿Qué es un adelanto de efectivo para comerciantes (MCA)?',
    answer: 'Es un tipo de financiamiento donde recibes capital a cambio de un porcentaje de tus ventas futuras. Es ideal para negocios que necesitan liquidez rápida y tienen ventas consistentes.'
  }, {
    question: '¿Puedo usar los fondos para cualquier propósito?',
    answer: 'Sí, puedes usar el financiamiento para lo que tu negocio necesite: inventario, nómina, expansión, equipos, marketing, renovaciones o cualquier gasto operativo.'
  }, {
    question: '¿Cuáles son los plazos de pago disponibles?',
    answer: 'Los plazos varían según el tipo de financiamiento y el prestamista. Pueden ir desde 3 meses hasta 5 años, dependiendo del producto y tu perfil de negocio.'
  }, {
    question: '¿Puedo obtener más de un financiamiento a la vez?',
    answer: 'Sí, dependiendo de la capacidad de pago de tu negocio, es posible tener múltiples financiamientos activos. Nuestro equipo te ayudará a evaluar la mejor estrategia.'
  }],
  'Cuenta y Seguridad': [{
    question: '¿Mi información está segura?',
    answer: 'Absolutamente. Utilizamos encriptación de nivel bancario de 256 bits para proteger toda tu información personal y financiera. Tu seguridad es nuestra prioridad.'
  }, {
    question: '¿Comparten mi información con terceros?',
    answer: 'Solo compartimos tu información con los prestamistas de nuestra red verificada para procesar tu solicitud de financiamiento. Nunca vendemos tu información a terceros.'
  }, {
    question: '¿Cómo puedo contactar al equipo de soporte?',
    answer: 'Puedes contactarnos por WhatsApp, correo electrónico o teléfono. Nuestro equipo bilingüe está disponible para atenderte en español e inglés.'
  }, {
    question: '¿Qué pasa si no estoy satisfecho con las ofertas?',
    answer: 'No tienes ninguna obligación de aceptar. Si las ofertas no te convencen, simplemente puedes rechazarlas sin costo alguno. Nuestro servicio de comparación es gratuito.'
  }, {
    question: '¿Cómo verifican a los prestamistas de su red?',
    answer: 'Todos nuestros prestamistas pasan por un proceso de verificación riguroso. Trabajamos solo con prestamistas privados de primer nivel, licenciados y con historial comprobado.'
  }]
};
export function FAQ() {
  const [activeTab, setActiveTab] = useState(tabs[0]);
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = faqsByTab[activeTab] || [];
  return <section id="faq" className="py-10 bg-white" data-id="element-80">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-81">
        <div className="text-center mb-8" data-id="element-82">
          <p className="text-xs font-bold tracking-widest text-gray-500 uppercase mb-2" data-id="element-83">
            Preguntas Frecuentes
          </p>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900" data-id="element-84">
            Respuestas a Tus Preguntas
          </h2>
        </div>

        {/* Tabs */}
        <div className="flex flex-wrap justify-center gap-2 mb-6" data-id="element-85">
          {tabs.map(tab => <button key={tab} onClick={() => {
          setActiveTab(tab);
          setOpenIndex(0);
        }} className={`px-3 py-1.5 rounded-md text-xs font-semibold transition-all duration-200 ${activeTab === tab ? 'bg-[#00E676] text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`} data-id="element-86">
              {tab}
            </button>)}
        </div>

        {/* Accordion */}
        <div className="border border-gray-200 rounded-lg overflow-hidden divide-y divide-gray-200" data-id="element-87">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={`${activeTab}-${index}`} className="bg-white" data-id="element-88">
                <button className="w-full px-5 py-4 text-left flex justify-between items-center focus:outline-none group" onClick={() => setOpenIndex(isOpen ? null : index)} data-id="element-89">
                  <span className={`text-sm font-bold transition-colors ${isOpen ? 'text-[#00E676]' : 'text-gray-900 group-hover:text-[#00E676]'}`} data-id="element-90">
                    {faq.question}
                  </span>
                  <ChevronDown className={`w-4 h-4 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'text-[#00E676] rotate-180' : 'text-gray-400'}`} data-id="element-91" />
                </button>
                {isOpen && <div className="px-5 pb-4" data-id="element-92">
                    <p className="text-sm text-gray-500 leading-relaxed" data-id="element-93">
                      {faq.answer}
                    </p>
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}